<!--<div class="col-12">
  <app-property-attributes-view [prop]="prop" [category]="category"></app-property-attributes-view>
</div>
<div
  *ngIf="prop && userHelper.canUpdateProperty(prop)"
  class="container-fluid d-flex flex-row-reverse mb-2 mt-2"
>
  <button class="mr-2" mat-mini-fab color="primary" mat-icon-button [matMenuTriggerFor]="menuWork">
    <mat-icon appTooltip="Ajouter des travaux">add</mat-icon>
  </button>
</div>

<mat-menu #menuWork="matMenu">
  <button mat-menu-item (click)="addWork()">Ajouter des travaux</button>
  <button mat-menu-item (click)="uploadDocWork()">Ajouter un document</button>
</mat-menu>
-->
<div class="col-12 mt-2">
  <app-property-work-table #workTable [prop]="prop"></app-property-work-table>
</div>
<div class="col-12 mt-2">
  <app-property-doc-view *ngIf="workTable.rawData" [prop]="prop" [category]="category" [works]="workTable.rawData">
  </app-property-doc-view>
</div>
